export enum EnrollmentCancellationStatusEnum {
  NA = 'NA', // Non applicable
  CANCELED_BY_PARENT = 'CANCELED_BY_PARENT', // Annulé par le parent
  CANCEL_CONFIRMED_BY_LEC = 'CANCEL_CONFIRMED_BY_LEC', // Annulé confirmé par le LEC
  CANCEL_REJECTED_BY_LEC = 'CANCEL_REJECTED_BY_LEC' // Annulé rejeté par le LEC
}

export const enrollmentCancellationStatusMapping: Record<
  EnrollmentCancellationStatusEnum,
  string
> = {
  [EnrollmentCancellationStatusEnum.NA]: 'Non applicable',
  [EnrollmentCancellationStatusEnum.CANCELED_BY_PARENT]: 'Annulé par le parent',
  [EnrollmentCancellationStatusEnum.CANCEL_CONFIRMED_BY_LEC]: 'Annulé confirmé par le LEC',
  [EnrollmentCancellationStatusEnum.CANCEL_REJECTED_BY_LEC]: 'Annulé rejeté par le LEC'
}
